import About from '../pages/About/About';
import Layout from '../components/Layout/Layout';
import NotFound from '../pages/NotFound/NotFound';
import { createBrowserRouter } from 'react-router-dom';
import { RoutePath } from './paths';
import Main from '../pages/Main/Main';
import Design from '../pages/Design/Design';
import Contacts from '../pages/Contacts/Contacts';

export default createBrowserRouter([
  {
    path: '/',
    element: <Layout />,
    errorElement: <NotFound />,
    children: [
      {
        path: '',
        element: <Main />,
      },
      {
        path: RoutePath.ABOUT,
        element: <About />,
      },
      {
        path: RoutePath.DEVELOPERS,
      },
      {
        path: RoutePath.DOCUMENTS,
        element: <NotFound />,
      },
      {
        path: RoutePath.CONTACTS,
        element: <Contacts />,
      },
      {
        path: RoutePath.FAQ,
        element: <NotFound />,
      },
      {
        path: RoutePath.PARTNERS,
        element: <NotFound />,
      },
      {
        path: RoutePath.PRICING,
        element: <NotFound />,
      },
      {
        path: RoutePath.LOGIN,
      },
      {
        path: RoutePath.DESING,
        element: <Design />,
      },
    ],
  },
]);
